<template>
    <!--设置新密码组件 -->
    <div class="retrieve-psw-container">
        <!-- <div class="syslogo-container">
            <img :src="syslogo">
            <a href="">{{$t('登录')}}</a>
        </div> -->
        <!-- header 部分 -->
        <portal-header :isShowUser='false'></portal-header>
        <div class="retrieve-form-div">
            <div class="form-container">
                <!-- 设置密码 -->
                <h1 class="title">{{$t('重置密码')}}</h1>
                <Form :model="formData"
                      v-show="!isSuccess"
                      ref="resetPassword"
                      class="reser-pwd-formContent"
                      label-position="left"
                      :rules="ruleData">
                    <FormItem prop="password"
                              :label="$t('新密码')">
                        <Input v-model="formData.password"
                               :maxlength='64'
                               type="password"
                               @copy.native.capture.prevent="handleCopy"
                               @cut.native.capture.prevent="handleCopy"
                               :placeholder="$t('8-12位英文、数字及特殊字符')" />
                    </FormItem>
                    <FormItem prop="confirmPassword"
                              :label="$t('确认新密码')">
                        <Input v-model="formData.confirmPassword"
                               :maxlength='64'
                               type="password"
                               @copy.native.capture.prevent="handleCopy"
                               @cut.native.capture.prevent="handleCopy"
                               :placeholder="$t('请再次输入密码')" />
                    </FormItem>
                    <Button type="primary"
                            class="submit"
                            :loading="loading"
                            @click="submitForm">
                        {{$t('提交')}}
                    </Button>
                </Form>
                <!-- 设置密码成功 -->
                <div v-show="isSuccess">
                    <div class="reser-pwd-formContent">
                        <!-- <img src="../../../../assets/images/successPsw.png"
                             alt="设置成功"> -->
                        <div class="common-demo passwd1"></div>
                        <p style="color:#59d476; font-size: 14px;">{{$t('密码修改成功')}}</p>
                        <p style="margin-top:22px">
                            <span>{{second}}</span>s{{$t('后自动跳转到主页，')}} {{$t('若未跳转，')}}{{$t('可')}}
                            <a href=""
                               @click="goLogin">{{$t('点击跳转')}}</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="footer">
            <p>Copyright © 北京佳杰云星数据科技有限公司粤ICP备17031727号-2</p>
        </div> -->
        <div class="footer">
            <p> <span>{{companyname}}</span>&nbsp;&nbsp;<span>{{copyright}}</span></p>
        </div>
    </div>
</template>
<script>
import portalHeader from '@c/portal/header'
import API from '@/service/api'
import { isPassword } from '@/service/validator.js'
export default {
    name: 'retrievePasswd',
    components: {
        portalHeader
    },
    data () {
        const validatePassCheck = (rule, value, callback) => {
            if (value !== this.formData.password) {
                callback(new Error(this.$i18n.t('密码不一致')))
            } else {
                callback()
            }
        }
        return {
            companyname: null,
            copyright: null,
            syslogo: this.$store.state.app.appConfig.sysLogo,
            loading: false,
            isSuccess: false,
            second: 3,
            formData: {
                password: '',
                confirmPassword: ''
            },
            ruleData: {
                password: [
                    { required: true, message: this.$i18n.t('该字段不能为空'), trigger: 'blur' },
                    { validator: isPassword, trigger: 'blur' }
                ],
                confirmPassword: [
                    {
                        required: true,
                        message: this.$i18n.t('该字段不能为空'),
                        trigger: 'blur'
                    },
                    { validator: isPassword, trigger: 'blur' },
                    { validator: validatePassCheck, trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        this.getPortalOem()
    },
    methods: {
        getPortalOem () {
            this.axios.get(this.urlFormat(API.GET_PORTAL_OEM, true), {
                headers: {
                    noAuth: true
                }
            }).then(res => {
                this.companyname = 'Copyright ©' + res.companyName
                this.copyright = res.preparedNumber || ''
            })
        },
        submitForm () {
            this.$refs.resetPassword.validate((valid) => {
                if (valid) {
                    let securityKey = this.$route.query.securityKey || ''
                    securityKey = securityKey.replace(/\s/g, '+') // 将所有空格替换为加号
                    var submitObj = {
                        newPassword: this.$encrypt(this.formData.password, true),
                        securityKey: securityKey
                    }
                    this.loading = true // 重置密码时加载动画
                    this.axios.post(this.urlFormat(API.POST_UPDATA_PWD, true), submitObj, {
                        headers: {
                            noAuth: true,
                            showMsg: false
                        }
                    }).then(res => {
                        this.loading = false
                        if (!res.status) {
                            this.isSuccess = false
                        } else {
                            this.isSuccess = true
                            setInterval(() => { this.second-- }, 1000)
                            setTimeout(() => { this.goLogin() }, this.second * 1000)
                        }
                    }).catch(e => {
                        this.loading = false
                    })
                }
            })
        },
        goLogin () {
            this.$router.push({ path: '/login' })
        },
        handleCopy () {
            // 不允许复制
            return false
        }
    }
}
</script>
<style lang="less">
.retrieve-psw-container {
    position: relative;
    .reser-pwd-formContent {
        .ivu-form-item {
            position: relative;
        }
        .ivu-form-item-label {
            position: absolute;
            z-index: 1;
            left: 7px;
            top: 1px;
            width: 86px;
            color: #333;
            font-size: 12px;
        }
        .ivu-form-item-label:before {
            content: '';
        }
        .ivu-form-item-label:after {
            content: '';
            display: inline-block;
            width: 0;
            height: 12px;
            border-right: 2px solid #cccccc;
            position: absolute;
            right: 4px;
            top: 12px;
        }
        .ivu-input {
            text-indent: 91px;
            border-radius: 0;
            height: 33px;
        }
    }
}
</style>
<style lang="less" scoped>
.retrieve-psw-container {
    width: 100%;
    height: 100%;
    background-image: url(../../../assets/images/retrievePsdBg.png);
    background-size: cover;
    .info {
        color: #ff7f27;
    }
    .syslogo-container {
        height: 50px;
        line-height: 50px;
        padding-left: 24px;
        padding-right: 24px;
        background: #2a303c;
        img {
            position: relative;
            width: 160px;
            margin-top: 5px;
        }
        a {
            float: right;
            color: #ffffff;
        }
    }
    .retrieve-form-div {
        width: 600px;
        height: 400px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -200px;
        margin-left: -300px;
        .form-container {
            height: 300px;
            background: #ffffff;
            .reser-pwd-formContent {
                width: 358px;
                margin: 0 auto;
                text-align: center;
                padding-top: 45px;
            }
            .title {
                height: 66px;
                line-height: 66px;
                font-weight: 400;
                font-size: 18px;
                text-align: center;
                border-bottom: 1px dashed #e9e9e9;
            }
            .submit {
                width: 88px;
                height: 32px;
                border: 0;
                border-radius: 0%;
                margin-top: 5px;
            }
        }
    }
    .footer {
        position: absolute;
        bottom: 0px;
        width: 100%;
        line-height: 20px;
        font-size: 12px;
        color: #808080;
        text-align: center;
        padding: 30px 0;
        width: 1170px;
        margin-left: -585px;
        border-top: 1px solid #e3e3e3;
        left: 50%;
    }
}
</style>
